function PrivacyPolicy() {
  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <a href="/" style={styles.link}>PTA Programs Dallas</a>
      </header>

      <main style={styles.main}>
        <h1 style={styles.heading}>Privacy Policy</h1>
        <p><strong>Last updated: January 1, 2026</strong></p>

        <p>
          PTA Programs Dallas, available at{' '}
          <a href="https://ptaprogramsdallas.com/" style={styles.link}>
            ptaprogramsdallas.com
          </a>
          , respects your privacy. This Privacy Policy explains what information may
          be collected when you visit this website and how it may be used.
        </p>

        <h2 style={styles.subheading}>Information We Collect</h2>
        <p>
          We do not require visitors to create accounts or provide personal information
          to browse the directory. Our hosting provider and analytics or security
          services may automatically receive limited technical information, such as
          your IP address, browser type, device type, pages viewed, referring website,
          and approximate visit time.
        </p>

        <h2 style={styles.subheading}>How We Use Information</h2>
        <p>
          Technical information may be used to operate, secure, maintain, analyze, and
          improve the website; understand how visitors use the directory; and identify
          technical problems or abusive activity. We do not sell personal information.
        </p>

        <h2 style={styles.subheading}>Cookies and Similar Technologies</h2>
        <p>
          This website may use cookies or similar technologies provided by hosting,
          analytics, advertising, embedded map, or external resource providers. You can
          manage or block cookies through your browser settings.
        </p>

        <h2 style={styles.subheading}>External Links and Embedded Content</h2>
        <p>
          This directory contains links to colleges, career schools, government
          agencies, professional organizations, maps, and other third-party websites.
          Those websites have their own privacy policies and practices. We are not
          responsible for the privacy, security, content, or accuracy of third-party
          websites.
        </p>

        <h2 style={styles.subheading}>Children’s Privacy</h2>
        <p>
          This website is intended for a general audience and is not directed toward
          children under 13. We do not knowingly collect personal information from
          children under 13.
        </p>

        <h2 style={styles.subheading}>Data Security</h2>
        <p>
          We use reasonable measures to help protect the website and information
          processed through it. However, no internet transmission or electronic storage
          method can be guaranteed to be completely secure.
        </p>

        <h2 style={styles.subheading}>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be
          posted on this page with an updated revision date.
        </p>

        <h2 style={styles.subheading}>Contact</h2>
        <p>
          If you have questions about this Privacy Policy, please use the contact
          information provided by the website owner or hosting provider.
        </p>
      </main>

      <footer style={styles.footer}>
        <a href="/" style={styles.link}>Return to PTA Programs Dallas</a>
      </footer>
    </div>
  );
}

const styles = {
  page: {
    background: '#f7f9fc',
    color: '#172638',
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1.7,
    minHeight: '100vh',
  },
  header: {
    borderBottom: '1px solid #dce4ed',
    margin: '0 auto',
    maxWidth: 900,
    padding: '28px 24px',
  },
  main: {
    background: '#fff',
    margin: '32px auto',
    maxWidth: 900,
    padding: '28px 24px',
  },
  footer: {
    borderTop: '1px solid #dce4ed',
    color: '#627083',
    fontSize: 14,
    margin: '0 auto',
    maxWidth: 900,
    padding: '28px 24px',
  },
  heading: {
    color: '#082f55',
    fontSize: 42,
    lineHeight: 1.2,
  },
  subheading: {
    color: '#082f55',
    lineHeight: 1.2,
    marginTop: 30,
  },
  link: {
    color: '#009cb6',
  },
};

export default PrivacyPolicy;